<template>
    <div>
        <el-dialog
            class="driver-info-dialog"
            :before-close="closeDialog"
            :visible.sync="dialogVisible"
            width="800px">
            <div slot="title">
                <span>司机信息</span>
                <el-button
                    size="mini"
                    style="margin-left: 10px;"
                    :icon="isSensitive ? 'icon-show' : 'icon-hidden'"
                    @click="handleSensitive"
                ></el-button>
            </div>
            <div v-loading="loading">
                <el-form ref="form" label-position="left" label-width="130px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="申请时间">
                                <el-input disabled v-model="form.createTime"></el-input>
                            </el-form-item>
                            <ocr-card-upload
                                :cardTitle="'身份证(人像面)'"
                                :flag="
                                    form.idCardFileName +
                                    '#' +
                                    form.idCardFileTemUrl +
                                    '#' +
                                    form.idCardFileId
                                "
                                :imgValue="form.idCardFileTemUrl"
                                :disabled="true"
                                @preview="handlePreviewFile" />
                            <el-form-item label="司机编码">
                                <el-input disabled v-model="form.driverCode"></el-input>
                            </el-form-item>
                            <el-form-item label="司机姓名">
                                <el-input disabled v-model="form.driverName"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证起始日期">
                                <el-input disabled v-model="form.idCardStartDate"></el-input>
                            </el-form-item>
                            <ocr-card-upload
                                :cardTitle="'驾驶证'"
                                :flag="
                                    form.drivingLicenceFileName +
                                    '#' +
                                    form.drivingLicenceFileTemUrl +
                                    '#' +
                                    form.drivingLicenceFileId
                                "
                                :imgValue="form.drivingLicenceFileTemUrl"
                                :disabled="true"
                                @preview="handlePreviewFile" />
                            <el-form-item label="驾驶证号">
                                <el-input disabled v-model="sensitiveData.drivingLicence"></el-input>
                            </el-form-item>
                            <el-form-item label="驾驶证起始日期">
                                <el-input disabled v-model="form.driveStartDate"></el-input>
                            </el-form-item>
                            <el-form-item label="驾驶证签发机关">
                                <el-input disabled v-model="form.driverLicenseAuthority"></el-input>
                            </el-form-item>
                            <el-form-item label="从业资格证">
                                <el-input disabled v-model="form.empCertificate"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="申请状态">
                                <el-input disabled v-model="applyStatusText"></el-input>
                            </el-form-item>
                            <ocr-card-upload
                                :cardTitle="'身份证(国徽面)'"
                                :flag="
                                    form.idCardBottomSideFileName +
                                    '#' +
                                    form.idCardBottomSideFileTemUrl +
                                    '#' +
                                    form.idCardBottomSideFileId
                                "
                                :imgValue="form.idCardBottomSideFileTemUrl"
                                :disabled="true"
                                @preview="handlePreviewFile" />
                            <el-form-item label="手机号码">
                                <el-input disabled v-model="sensitiveData.phoneNo"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证号码">
                                <el-input disabled v-model="sensitiveData.idCard"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证到期日期">
                                <el-input disabled v-model="form.idCardEndDate"></el-input>
                            </el-form-item>
                            <ocr-card-upload
                                :cardTitle="'从业资格证'"
                                :flag="
                                    form.empCertificateFileName +
                                    '#' +
                                    form.empCertificateFileTemUrl +
                                    '#' +
                                    form.empCertificateFileId
                                "
                                :imgValue="form.empCertificateFileTemUrl"
                                :disabled="true"
                                @preview="handlePreviewFile" />
                            <el-form-item label="准驾车型">
                                <el-input disabled v-model="form.driveType"></el-input>
                            </el-form-item>
                            <el-form-item label="驾驶证到期日期">
                                <el-input disabled v-model="form.driveEndDate"></el-input>
                            </el-form-item>
                            <el-form-item label="驾驶证初次领证日期">
                                <el-input disabled v-model="form.dateIssue"></el-input>
                            </el-form-item>
                            <el-form-item label="司机与安得合作时长">
                                <el-input disabled v-model="form.cooperationPeriod"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeDialog">关闭</el-button>
            </span>
        </el-dialog>

        <preview v-if="attachmentShow" :attachmentShow.sync="attachmentShow" :rowData="rowData"></preview>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import OcrCardUpload from '../../../../components/ocrCardUpload/Index.vue'
import preview from '../../../../components/viewAttachment.vue'
import { getDriverInfo } from '../../../../api/driverAddSupplier.js'
import { getSensitiveVal } from '../../../../utils/common.js';
import common from '../../../../api/common.js';
export default {
    props: ['dialogVisible', 'applyCode', 'applyStatusText'],
    components: { OcrCardUpload, preview },
    data() {
        return {
            attachmentShow: false,
            rowData: {},
            form: {},
            loading: false,
            isSensitive: true,
        }
    },
    watch: {
        dialogVisible(v) {
            if (v && this.applyCode) {
                this.loading = true
                getDriverInfo(this.applyCode).then(res => {
                    if (res && +res.code === 0) {
                        res.data.phoneNo_ = getSensitiveVal(res.data.phoneNo, 'phone')
                        res.data.idCard_ = getSensitiveVal(res.data.idCard, 'idCard')
                        res.data.drivingLicence_ = getSensitiveVal(res.data.drivingLicence, 'idCard')
                        res.data.idCardStartDate = res.data.idCardStartDate ? dayjs(res.data.idCardStartDate).format('YYYY-MM-DD') : ''
                        res.data.driveStartDate = res.data.driveStartDate ? dayjs(res.data.driveStartDate).format('YYYY-MM-DD') : ''
                        res.data.idCardEndDate = res.data.idCardEndDate ? dayjs(res.data.idCardEndDate).format('YYYY-MM-DD') : ''
                        res.data.driveEndDate = res.data.driveEndDate ? dayjs(res.data.driveEndDate).format('YYYY-MM-DD') : ''
                        res.data.dateIssue = res.data.dateIssue ? dayjs(res.data.dateIssue).format('YYYY-MM-DD') : ''
                        this.form = res.data
                    }
                }).finally(() => {
                    this.loading = false
                })
            }
            if(!v){
                this.isSensitive = true
            }
        },
    },
    computed: {
        sensitiveData(){
            return {
                phoneNo: this.isSensitive ? this.form.phoneNo_ : this.form.phoneNo,
                idCard: this.isSensitive ? this.form.idCard_ : this.form.idCard,
                drivingLicence: this.isSensitive ? this.form.drivingLicence_ : this.form.drivingLicence,
            }
        }
    },
    methods: {
        handleSensitive(){
            this.isSensitive = !this.isSensitive
             if (!this.isSensitive) {
                common.operationRecord({ operationModule: `司机加入供应商申请-司机信息` });
            }
        },
        handlePreviewFile(obj) {
            this.rowData.downUrl = obj
            this.attachmentShow = true
        },
        closeDialog() {
            this.$emit('update:dialogVisible', false)
        },
    },
}
</script>
<style lang="less" >
.driver-info-dialog {
    .box-card {
        margin-bottom: 22px;
    }
    .ocr-upload-container {
        height: 170px !important;
    }
    .el-col {
        padding-left: 15px !important;
        padding-right: 15px !important;
    }
    .el-form-item__label,
    .el-form-item__content {
        line-height: 28px;
    }
}
</style>
